module.exports = __webpack_public_path__ + "img/icon_noimg.5b2dbbd0.png";